import { ModuleConfig } from "@core/interfaces";
import { name as members } from "@modules/Members/reducers/members";

const config: ModuleConfig = {
  name: "Members",
  baseUrl: "",
  routes: [
    {
      path: "/admin/warehouse",
      page: "WarehousePage",
      title: "Warehouse Page",
      exact: true,
      //   reducer: {
      //     name: members,
      //     resource: "members",
      //   },
    },
  ],
  requireAuthenticated: true,
};

export default config;
